// @flow
import { createContext } from 'react'

export type AnalyticContextType = {
  prefix: string,
  module: string,
  payload?: ?{ ... },
  ...
}

const AnalyticContext = createContext<AnalyticContextType>({
  prefix: 'app',
  module: '',
  payload: null,
})

export { AnalyticContext }
